import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "./AddItem.scss";

import itemsJson from "../../datas/items.json";

import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ListItem from "../../components/additem/ListItem";
import ItemDetail from "../../components/additem/ItemDetail";
import PriceDetail from "../../components/additem/PriceDetail";

import arrowUp from "../../images/icon/icon-arrow-up.png";
import arrowDown from "../../images/icon/icon-arrow-down.png";

export default function AddItem() {
  const [items, setItems] = useState(itemsJson);
  const [listLength, setListLength] = useState(
    window.innerHeight > window.innerWidth ? 10 : 7
  );

  const lastIdx = (items.length % listLength) - 1;
  const totalPage = Math.ceil(items.length / listLength);

  const [currIdx, setCurrIdx] = useState(3);
  const [pageNum, setPageNum] = useState(1);
  const [itemList, setItemList] = useState(getItemList(1, listLength));

  const getLength = () => {
    let len = window.innerHeight > window.innerWidth ? 10 : 7;
    getNewItemList(currIdx, len, pageNum);
    setListLength(len);
  };

  useEffect(() => {
    window.addEventListener("resize", getLength);
    return () => {
      // clean up
      window.addEventListener("resize", getLength);
    };
  }, []);

  function selectListener(index) {
    setCurrIdx(index);
  }

  function getNewItemList(currIdx, listLength, pageNum) {
    setCurrIdx(currIdx >= listLength ? 0 : currIdx);
    let pageNumber =
      pageNum <= Math.ceil(items.length / listLength) ? pageNum : 1;
    setPageNum(pageNumber);
    setItemList(getItemList(pageNumber, listLength));
  }

  function getItemList(pageNum, listLen) {
    const arr = items.slice((pageNum - 1) * listLen, pageNum * listLen);
    if (arr.length < listLen) {
      return arr.concat(new Array(listLen - arr.length).fill({}));
    }
    return arr;
  }

  function keybordListener(e) {
    switch (e.key) {
      case "ArrowUp":
        if (currIdx === 0 && pageNum === 1) return;
        currIdx === 0 && pageNum > 1
          ? getNewItemList(listLength - 1, listLength, pageNum - 1)
          : getNewItemList(currIdx - 1, listLength, pageNum);
        break;
      case "ArrowDown":
        if (currIdx === lastIdx && pageNum === totalPage) return;
        currIdx === itemList.length - 1
          ? getNewItemList(0, listLength, pageNum + 1)
          : getNewItemList(currIdx + 1, listLength, pageNum);
        break;
      case "*":
        let currItem = itemList[currIdx];
        currItem.saleQty += 1;
        currItem.totAmt = currItem.saleQty * currItem.salePrice;
        if (currItem.offerCd === "0000000021" && currItem.saleQty > 2) {
          currItem.discountTotal =
            Math.floor(currItem.saleQty / (2 + 1)) * currItem.salePrice;
          currItem.totAmt -= currItem.discountTotal;
        }
        let newList = items;
        newList.splice(newList.indexOf(itemList[currIdx]), 1, currItem);
        setItems(newList);
        setItemList(getItemList(pageNum, listLength));
        break;
      default:
        return;
    }
  }

  function setPage(arrow) {
    if (arrow < 0 && pageNum > 1) {
      getNewItemList(currIdx, listLength, pageNum - 1);
    } else if (arrow > 0 && pageNum < totalPage) {
      let idx = currIdx;
      if (pageNum + 1 === totalPage && currIdx > lastIdx) {
        idx = lastIdx;
      }
      getNewItemList(idx, listLength, pageNum + 1);
    }
  }

  return (
    <div className="add-item" tabIndex="0" onKeyDown={keybordListener}>
      <Header
        linkTo="/"
        scoMsg={"상품을 등록해주세요"}
        kioskMsg={"상품을\r\n등록해주세요"}
      />
      <div className="body">
        <div className="left-area">
          <div className="item-list">
            <div className="thead">
              <div>상품명/단가</div>
              <div>수량</div>
              <div>합계</div>
              <div>비고</div>
            </div>
            <div className="tbody">
              {itemList.map((i, index) => (
                <ListItem
                  func={() => selectListener(index)}
                  data={i}
                  curr={currIdx === index}
                  key={index}
                />
              ))}
            </div>
            <div className="pagination">
              <img src={arrowUp} alt="page-up" onClick={() => setPage(-1)} />
              <p>
                {pageNum} / {totalPage}
              </p>
              <img src={arrowDown} alt="page-down" onClick={() => setPage(1)} />
            </div>
          </div>
        </div>
        <div className="right-area">
          <ItemDetail data={itemList[currIdx]} />
          <PriceDetail data={items} />
        </div>
      </div>
      <div className="footer-add-item">
        <div className="footer-call">호출</div>
        <div className="footer-sale-bag">봉투 구매</div>
        <Link
          to="/preset"
          style={{ color: "inherit", textDecoration: "inherit" }}
        >
          <div className="footer-preset">과일·채소 직접입력</div>
        </Link>
        <div className="footer-add-coupon">쿠폰 등록</div>
        <Link
          to="/preset"
          style={{ color: "inherit", textDecoration: "inherit" }}
        >
          <div className="footer-preset-kiosk">과일 채소 입력</div>
        </Link>
        <div className="footer-pay">결제하기</div>
      </div>
      <Footer />
    </div>
  );
}
